export default __webpack_public_path__ + "static/media/logo_white.84c2cef2.svg";